
import { EMPTY_REFUND_SEARCH_CRITERIA } from "domain/entity/Refund/RefundSearchCriteria";
import moment from "moment";
import { useRefundVM } from "presentation/hook/Refund/useRefundVM";
import { useRefundTracked } from "presentation/store/Refund/RefundProvider";
import { useEffect, useState } from "react";
import { Loader, SliderPanel } from "veronica-ui-component/dist/component/core";
import RefundEditPanel from "./RefundEditPanel";
import { RefundRightPanel } from "./RefundRightPanel";
import RefundSearchPanel from "./RefundSearchPanel";
import RefundTitleBar from "./RefundTitleBar";

export const RefundMaintenance: React.FC = () => {
    const [refundState] = useRefundTracked();
    const refundVM = useRefundVM();
    const { isShowSearchPanel, isShowEditPanel } = refundState;
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        refundVM.setIsSearchLoading(true);
        const initialScreen = async () => {
            await Promise.allSettled([
                refundVM.loadDropdownOption(),
            ]);
        }
        initialScreen().then(async (data) => {
            let criteria = { ...EMPTY_REFUND_SEARCH_CRITERIA };
            criteria = {
                ...criteria,
                refundType: refundState.dynamicOptions.refundTypeDropdownOptions[0].value ?? "",
                status: refundState.dynamicOptions.statusDropdownOptions[0].value ?? "",
                createdDateTimeFrom: moment().subtract(1, 'day').startOf('day').toDate(),
                createdDateTimeTo: moment().startOf("day").toDate(),
            }
            await refundVM.onSearch(criteria).then(data => {
                setIsLoading(false);
                refundVM.setIsSearchLoading(false);
            }).catch(error => {
                setIsLoading(false);
                refundVM.setIsSearchLoading(false);
            });
        }).catch(error => {
            setIsLoading(false);
            refundVM.setIsSearchLoading(false);
        });

    }, [refundState.dynamicOptions.refundTypeDropdownOptions, refundState.dynamicOptions.statusDropdownOptions, refundVM])

    if (isLoading) return <Loader Indicator="Stripe" size="Large" />;

    return <>
        <div className={`main-comp-wrapper${(isShowSearchPanel) ? '' : ' im-hide-side-form-draggable'}`}>
            {isShowEditPanel && <RefundEditPanel />}
            {!isShowEditPanel &&
                <>
                    <RefundTitleBar />
                    <SliderPanel
                        isOpen={true}
                        draggable={false}
                        leftSectionWidth={isShowSearchPanel ? '30%' : '0%'}
                        rightSectionWidth={isShowSearchPanel ? "70%" : '100%'}
                        leftChildren={<RefundSearchPanel />}
                        rightChildren={<RefundRightPanel />}
                    />
                </>
            }
        </div>
    </>
}